import { createAsyncThunk } from "@reduxjs/toolkit";
import { isApiError } from "src/api/utils/enhancedFetch";
import {
  fetchAccountNotifiers,
  updateAllSubscriptions,
  updateBroadcasterSubscription,
} from "src/features/profile/settings/api/profileApi";
import {
  AccountNotifierResponse,
  AccountNotifierSubscriptionPayload,
} from "src/features/profile/settings/types";

export const fetchAccountNotifiersAction =
  createAsyncThunk<AccountNotifierResponse>(
    "lwc/profile/settings/liveNotifications/fetchAccountNotifiersAction",
    async (_, api) => {
      try {
        return await fetchAccountNotifiers();
      } catch (e) {
        const error = isApiError(e) ? e.statusText : (e as Error).message;

        return api.rejectWithValue(error);
      }
    }
  );

export const updateSubscriptionAction = createAsyncThunk<
  Response,
  AccountNotifierSubscriptionPayload
>(
  "lwc/profile/settings/liveNotifications/updateSubscription",
  async (data, api) => {
    try {
      return await updateBroadcasterSubscription(data);
    } catch (e) {
      const error = isApiError(e) ? e.statusText : (e as Error).message;

      return api.rejectWithValue(error);
    }
  }
);

export const updateAllSubscriptionsAction = createAsyncThunk<
  Response,
  Omit<AccountNotifierSubscriptionPayload, "notifierId">
>(
  "lwc/profile/settings/liveNotifications/updateAllSubscriptions",
  async (data, api) => {
    try {
      return await updateAllSubscriptions(data);
    } catch (e) {
      const error = isApiError(e) ? e.statusText : (e as Error).message;

      return api.rejectWithValue(error);
    }
  }
);
